import React from 'react'
import dizzyRobotSrc from 'images/svg/dizzy_robot.svg'
import { Link } from 'react-router'
import './style.styl'

const ErrorState = () => (
  <div className="sfdc-mapping-error">
    <img src={dizzyRobotSrc}/>
    <h3>Uh oh! Something went wrong.</h3>
    <Link to="/settings/salesforce/event-log">See the event log for more details</Link>
  </div>
)

export default ErrorState


// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/SalesforceMapping/ErrorState.js